import React, { Fragment } from "react";

const EmploymentTypeItem = ({
  setFilters,
  filters,
  setIsChecked,
  isChecked,
  item,
  index,
}) => {
  return (
    <Fragment>
      <div className="flex-only">
        {filters.employmenttype === "" && (
          <div>
            <input
              type="checkbox"
              name="employment-type"
              className="job-type"
              value={item.employmenttype}
              onChange={(e) => {
                if (!isChecked.employmenttype) {
                  setFilters({ ...filters, employmenttype: e.target.value });
                  setIsChecked({ ...isChecked, employmenttype: true });
                } else {
                  setFilters({ ...filters, employmenttype: "" });
                  setIsChecked({ ...isChecked, employmenttype: false });
                }
              }}
            />
            <span className="job-type mt" key={index}>
              {item.employmenttype}
            </span>
            <br />
          </div>
        )}
        {item.employmenttype === filters.employmenttype && (
          <div>
            <input
              type="checkbox"
              name="employment-type"
              className="job-type"
              checked
              value={item.employmenttype}
              onChange={(e) => {
                if (!isChecked.employmenttype) {
                  setFilters({ ...filters, employmenttype: e.target.value });
                  setIsChecked({ ...isChecked, employmenttype: true });
                } else {
                  setFilters({ ...filters, employmenttype: "" });
                  setIsChecked({ ...isChecked, employmenttype: false });
                }
              }}
            />
            <span className="job-type mt" key={index}>
              {item.employmenttype}
            </span>
            <br />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default EmploymentTypeItem;
